import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: null
    },

    mutations: {
        setUser(state, user) {
            state.user = user
            if (user) {
                // Se usuário foi setado corretamente, então define token para novas requests no header global.
                axios.defaults.headers.common['Authorization'] = `bearer ${user.token}` 
            } else {
                delete axios.defaults.headers.common['Authorization']
            }
        }
    }
})